import {
  HostEnvironment,
  PaldeskRemoteVersions,
} from '@paldesk/module-federation/core';
import { HeaderTestRemoteVersion } from '@paldesk/module-federation/remotes-registry';

// used to make sure all environments have same properties
export class EnvironmentBase {
  static remotes: PaldeskRemoteVersions = {
    ...HeaderTestRemoteVersion,
  };

  static environment: HostEnvironment = 'test';
  static production = false;
  static buildId = '';
  static application_insights_key = '';
  static google_analytics_id = '';
  static palfinger_api_management = '';
  static palfinger_api_management_subs_key = '';
  static palfinger_app_gateway = '';
  static palfinger_app_gateway_v2 = '';
  static oidc_clientid = '';
  static oidc_scope = '';

  static LINKS: {
    SECURITY_TOKEN_SERVICE: string;
    POST_LOGOUT_REDIRECT_URI: string;
    PALDESK_BASEPATH: string;
    HOME: string;
    APP_HELP_PATH: string;
    APP_NEWS_PATH: string;
    STATUS_PALDESK_PAGE: string;
  } = {
    SECURITY_TOKEN_SERVICE: '',
    POST_LOGOUT_REDIRECT_URI: '',
    PALDESK_BASEPATH: '',
    HOME: '',
    APP_NEWS_PATH: '',
    APP_HELP_PATH: '',
    STATUS_PALDESK_PAGE: '',
  };

  static roles: string[] = [];

  static domainsForApiManagementSubsKey: string[];

  static identityServerAuthConf: {
    whitelistedDomains: string[];
    whitelistedRoutes: string[];
  } = {
    whitelistedDomains: [],
    whitelistedRoutes: [],
  };
  static FEATUREFLAGS: {
    USE_CSI_SURVEY: string;
  } = {
    USE_CSI_SURVEY: '',
  };
}
